import settings from '../config/settings';

export function isMobile() {
  const mq = window.matchMedia('(max-width:640px)');
  return mq.matches;
}

export function isTablet() {
  const mq = window.matchMedia('(max-width:1024px)');
  return mq.matches;
}

export function isDesktop() {
  const mq = window.matchMedia('(min-width:1025px)');
  return mq.matches;
}

export function sortPersons(a, b) {
  const orderBy = settings.sortOrder.persons;
  if (orderBy.dir === 1) {
    return a[orderBy.field] > b[orderBy.field];
  } else {
    return a[orderBy.field] < b[orderBy.field];
  }
}

export function sortObjects(a, b) {
  const orderBy = settings.sortOrder.objects;
  if (orderBy.dir === 1) {
    return a[orderBy.field] > b[orderBy.field];
  } else {
    return a[orderBy.field] < b[orderBy.field];
  }
}

export function sortContents(a, b) {
  const orderBy = settings.sortOrder.contents;
  if (orderBy.dir === 1) {
    return a[orderBy.field] > b[orderBy.field];
  } else {
    return a[orderBy.field] < b[orderBy.field];
  }
}

export function sortMultimedia(a, b) {
  const orderBy = settings.sortOrder.multimedia;
  if (orderBy.dir === 1) {
    return a[orderBy.field] > b[orderBy.field];
  } else {
    return a[orderBy.field] < b[orderBy.field];
  }
}

export function objectTitle(obj) {
  let s = '';

  if (obj.ObjObjectTitleTxt) {
    s = obj.ObjObjectTitleTxt;
  }
  if (!!obj.ObjObjectTitleSubTxt && !!obj.ObjObjectTitleSubTxt.trim()) {
    s = s.concat(`/${obj.ObjObjectTitleSubTxt.trim()}`);
  }
  if (!!obj.ObjDateGrp_DateFromTxt && !!obj.ObjDateGrp_DateFromTxt.trim()) {
    if (s.length > 0) {
      s = s.concat(', ');
    }
    s = s.concat(obj.ObjDateGrp_DateFromTxt.trim());
  }
  return s;
}

export function personSubTitle(person) {
  if (person.PerTypeVoc === 'Designer') {
    return person.PerDatingTxt;
  } else {
    let placeAndCountry = [];
    !!person.PerBirthPlaceCity
      ? placeAndCountry.push(person.PerBirthPlaceCity)
      : null;
    !!person.PerBirthPlaceCountry
      ? placeAndCountry.push(person.PerBirthPlaceCountry)
      : null;
    return placeAndCountry.length ? placeAndCountry.join(', ') : null;
  }
}

export function groupBy(array, f) {
  var groups = {};
  array.forEach(function(o) {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function(group) {
    return groups[group];
  });
}

export function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function redirectIfExpired() {}

export function getActiveSlide() {
  let activeSlide;
  const queryString = window.location.hash.split('?')[1];
  const key = 'activeSlide';
  if (queryString.indexOf(key) > -1) {
    const keyValuePairs = queryString.split('&');
    _.each(keyValuePairs, pair => {
      if (pair.indexOf(key) > -1) {
        activeSlide = parseInt(pair.split('=')[1]);
      }
    });
  }
  return activeSlide;
}



// WEBPACK FOOTER //
// ./app/common.js